import React from 'react'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import Link from '../../utils/link'

import { Arrow } from '../icons'

const CategoryCard = ({ title = '', excerpt = '', uri = '', featuredImage = null, sites }) => {

  const show = !!sites?.nodes?.find(site => site.slug === process.env.GATSBY_WP_CATEGORY_SITE_SLUG)
  if (sites?.nodes?.length > 0 && !show) return null

  return (
    <Link to={uri} className='category-card'>
      <div className='category-card__image'>
        { featuredImage?.node?.localFile && <GatsbyImage loading='lazy' image={getImage(featuredImage?.node.localFile)} alt={title} /> }
      </div>
      <h3>
        <span>{ title }</span>
        <Arrow />
      </h3>
      <div className='category-card__excerpt' dangerouslySetInnerHTML={{ __html: excerpt }} />
    </Link>
  )
}

export default CategoryCard